import React from 'react';
import { BookOpenIcon, CalendarIcon, ClockIcon, CreditCardIcon, FileTextIcon, GiftIcon, LockIcon, PrinterIcon, ShieldCheckIcon, StarIcon, UsersIcon } from 'lucide-react';
import { mockupUrl } from '../data/content';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-16" data-id="element-162" data-mp="4mrul1r1q1lr">
      <div className="pointer-events-none absolute left-1/2 top-[18%] h-[540px] w-[540px] -translate-x-1/2 rounded-full bg-primary/10 blur-[110px]" data-id="element-163" data-mp="12a0j75mcfqrz" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-164" data-mp="xb5w3rhcfg22">
        <div className="mb-5 inline-flex rounded-full border border-primary/20 bg-primary/10 px-4 py-1.5 font-display text-[11px] font-bold uppercase tracking-wider text-accent md:mb-7" data-id="element-165" data-mp="sa9s7dwzrtwn">
          🏥 Compra Digital Ya™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-extrabold leading-[1.1] tracking-tight text-slate-900 md:text-6xl" data-id="element-166" data-mp="3d2tln1u126au">
          Tu programa completo de espalda y columna,{' '}
          <span className="text-accent" data-id="element-167" data-mp="3j924lm8avmuh">listo desde hoy.</span>
        </h1>
        <a href="#pricing" className="group my-5 flex justify-center rounded-3xl focus:outline-none md:my-7" aria-label="Ver las opciones de compra del Combo Completo Espalda y Columna 2026" data-id="element-168" data-mp="3o6kfhi5voc54">
          <img className="w-full max-w-[620px] object-contain drop-shadow-[0_24px_38px_rgba(14,165,233,.25)] transition-transform duration-300 group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Espalda y Columna 2026 con sus 5 tomos y 5 bonos" data-id="element-169" data-mp="3e7l7m1sxskj6" />
        </a>
        <p className="mx-auto max-w-3xl text-base font-medium leading-relaxed text-slate-600 md:text-xl" data-id="element-170" data-mp="2viy25i6ult52">
          <strong className="text-slate-900" data-id="element-171" data-mp="2hjf63nrba894">COMBO COMPLETO ESPALDA Y COLUMNA 2026.</strong> El
          programa más completo de Argentina para personas que quieren dejar de tener dolor de
          espalda, mejorar su postura y fortalecer su columna de forma progresiva y segura.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-slate-600 md:text-sm" data-id="element-172" data-mp="nbbev44vul7x">
          <span className="flex items-center gap-1.5" data-id="element-173" data-mp="ibgm0v1jrlk8">
            <FileTextIcon className="h-4 w-4 text-accent" data-id="element-174" data-mp="ia5kl1vkqpwa" />
            100% PDF
          </span>
          <span className="flex items-center gap-1.5" data-id="element-175" data-mp="db2dzczy4bm7">
            <ClockIcon className="h-4 w-4 text-accent" data-id="element-176" data-mp="1azukfbwjsjwb" />
            Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-177" data-mp="162ugb6j9dr7u">
            <CalendarIcon className="h-4 w-4 text-accent" data-id="element-178" data-mp="112pvx5f8cccc" />
            Edición 2026
          </span>
          <span className="flex items-center gap-1.5" data-id="element-179" data-mp="x14pa1tagual">
            <PrinterIcon className="h-4 w-4 text-accent" data-id="element-180" data-mp="x0l50eg61tte" />
            Listo para usar hoy
          </span>
        </div>
        <div className="mt-7" data-id="element-181" data-mp="3lquenodz0752">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-182" data-mp="3hrlkiif0q78z">
            QUIERO EL COMBO COMPLETO ESPALDA Y COLUMNA
          </Button>
        </div>
        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-slate-500 md:text-sm" data-id="element-183" data-mp="21awco6qesnfd">
          <span className="flex items-center gap-1" data-id="element-184" data-mp="269r4fy6ctmbm">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-185" data-mp="267wj4ir67s70" />
            Garantía 7 días
          </span>
          <span className="text-sky-300" data-id="element-186" data-mp="2b2k6geafugk0">·</span>
          <span className="flex items-center gap-1" data-id="element-187" data-mp="2fyr8hvzpr7wo">
            <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-188" data-mp="2kyvo7jssrylu" />
            Pago seguro
          </span>
          <span className="text-sky-300" data-id="element-189" data-mp="2p0h6xls0j73y">·</span>
          <span className="flex items-center gap-1" data-id="element-190" data-mp="2p1sabkhjqcuj">
            <CreditCardIcon className="h-3.5 w-3.5 text-accent" data-id="element-191" data-mp="2tzlj8la8hkyi" />
            Mercado Pago
          </span>
        </div>
        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-192" data-mp="un98zl8qqfe3">
          <TrustCard icon={<UsersIcon className="h-5 w-5 text-accent" data-id="element-194" data-mp="zmluo2nvlgf3" />} text="+500 personas ya usan el programa" data-id="element-193" data-mp="zlaro5298cp1" />
          <TrustCard icon={<BookOpenIcon className="h-5 w-5 text-accent" data-id="element-196" data-mp="4d75t1sa75zs" />} text="5 Tomos listos para usar" data-id="element-195" data-mp="49t1vp3yyoq8" />
          <TrustCard icon={<GiftIcon className="h-5 w-5 text-accent" data-id="element-198" data-mp="e9tn5glefex2" />} text="5 Bonos incluidos gratis" data-id="element-197" data-mp="e9k1g57dztx6" />
          <TrustCard icon={<StarIcon className="h-5 w-5 fill-gold text-gold" data-id="element-200" data-mp="98e4fv6p1khu" />} text="4.9/5 · ★★★★★" data-id="element-199" data-mp="9bs7l5n6lxqc" />
        </div>
      </div>
    </section>;
}
function TrustCard({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center gap-2 rounded-2xl border border-sky-100 bg-white p-3 shadow-sm" data-id="element-201" data-mp="3rglptbnegipa">
      <span data-id="element-202" data-mp="3mp3lcdm63zzk">{icon}</span>
      <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-203" data-mp="3mnslupzr9ee9">
        {text}
      </span>
    </div>;
}